import { FC } from 'react';
import { LoadingButton } from '@mui/lab';
import clsx from 'clsx';

import './GradientBorderButton.scss';

interface GradientBorderButtonProps {
  children: React.ReactNode;
  disabled?: boolean;
  loading?: boolean;
  onClick: () => void;
  className?: string;
  borderWidth?: number;
  gradientColor1?: string;
  gradientColor2?: string;
  gradientColor3?: string;
}

const GradientBorderButton: FC<GradientBorderButtonProps> = ({
  children,
  disabled = false,
  loading = false,
  className = '',
  onClick,
  borderWidth = 2,
  gradientColor1 = '#853ce2',
  gradientColor2 = '#b32d9e',
  gradientColor3 = '#e01d5a',
  ...props
}) => {
  return (
    <LoadingButton
      disabled={disabled}
      loading={loading}
      className={clsx('gradient-border-button', className)}
      onClick={onClick}
      style={{
        '--gradient-color-1': gradientColor1,
        '--gradient-color-2': gradientColor2,
        '--gradient-color-3': gradientColor3,
        '--border-width': `${borderWidth}px`,
      } as React.CSSProperties}
      {...props}
    >
      {children}
    </LoadingButton>
  );
};

export default GradientBorderButton;
